import type { Plant, PlantStatus } from '../../utils/Chloromance/types';
import { formatPlantLocation, getPlantCount } from '../../utils/Chloromance/utils/plants';

type WaterTodaySectionProps = {
  plants: Plant[];
  statuses: Record<string, PlantStatus>;
  onWater: (plantIds: string[], celebrate?: boolean) => void;
};

export function WaterTodaySection({ plants, statuses, onWater }: WaterTodaySectionProps) {
  const duePlants = plants
    .filter((plant) => {
      const state = statuses[plant.id]?.state;
      return state === 'Critical' || state === 'Thirsty';
    })
    .sort((a, b) => statuses[a.id].moisture - statuses[b.id].moisture);
  const duePlantCount = duePlants.reduce((total, plant) => total + getPlantCount(plant), 0);

  return (
    <section className="water-today-section" aria-labelledby="water-today-title">
      <div className="water-today-header">
        <div>
          <p>Water Today</p>
          <h2 id="water-today-title">
            {duePlantCount > 0
              ? `${duePlantCount} plant${duePlantCount === 1 ? ' needs' : 's need'} care`
              : 'All caught up'}
          </h2>
        </div>
        {duePlants.length > 0 && (
          <button type="button" onClick={() => onWater(duePlants.map((plant) => plant.id), true)}>
            Water all
          </button>
        )}
      </div>

      {duePlants.length > 0 ? (
        <div className="water-today-list">
          {duePlants.slice(0, 4).map((plant) => {
            const status = statuses[plant.id];
            return (
              <article key={plant.id} className={`water-today-item state-${status.state.toLowerCase()}`}>
                <span>
                  <strong>{plant.name}</strong>
                  <small>{formatPlantLocation(plant.chloromance_zone)} · x{getPlantCount(plant)} · {status.nextWateringText}</small>
                </span>
                <b>{status.moisture}%</b>
                <button type="button" onClick={() => onWater([plant.id])}>
                  Water
                </button>
              </article>
            );
          })}
          {duePlants.length > 4 && <small className="water-today-more">+{duePlants.length - 4} more in the plant list</small>}
        </div>
      ) : (
        <p className="water-today-empty">No thirsty or critical plants right now.</p>
      )}
    </section>
  );
}
